import { Injectable } from '@angular/core';
import { BehaviorSubject, asyncScheduler } from 'rxjs';
import { observeOn } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private loaderSubject = new BehaviorSubject<boolean>(false);

  // Emit on the async scheduler so loader state changes triggered during a
  // change-detection cycle (e.g. an HTTP request fired in ngOnInit) land in a
  // new tick. This avoids NG0100 ExpressionChangedAfterItHasBeenCheckedError.
  loaderState = this.loaderSubject.asObservable().pipe(observeOn(asyncScheduler));

  show() {
    this.loaderSubject.next(true);
  }

  hide() {
    this.loaderSubject.next(false);
  }
}